import React from "react";
import { ReportsAnalytics } from "../../components/molecules/ReportsAnalytics";

export const ViewReports: React.FC = () => {
  return <ReportsAnalytics />;
};
